import type { ComponentType, ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({
  icon: Icon = Inbox,
  title,
  children,
  action,
  className = '',
}: {
  icon?: ComponentType<{ className?: string; 'aria-hidden'?: boolean | 'true' }>;
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`flex animate-fade flex-col items-center justify-center gap-3 rounded-box border border-dashed border-base-content/15 bg-base-100/40 px-6 py-12 text-center ${className}`}>
      <span className="dr-tint-primary grid size-12 place-items-center rounded-full">
        <Icon className="size-6" aria-hidden="true" />
      </span>
      <h3 className="font-semibold">{title}</h3>
      {children ? <div className="max-w-prose text-sm text-base-content/65">{children}</div> : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
